import { authenStorage } from "src/common/Storage";

export default function authHeader() {
  const authen = authenStorage.getAuthen();

  if (authen && authen.accessToken) {
    return { Authorization: "Bearer " + authen.accessToken };
  } else {
    return {};
  }
}
